export interface ActionType{
  title: string;
  tipo: string;
}

export const UPDATE:ActionType = {
  title:"Editar Periodo",
  tipo:"U"
}

export const CREATE: ActionType = {
  title:"Nuevo Periodo",
  tipo:"I"
}

export const STATES = {
  abierto: "Abierto",
  cerrado: "Cerrado",
  sinIniciar: "Sin Iniciar",
  abrir: "Abrir",
  cerrar: "Cerrar",
  abrirCerrar: "Abrir/Cerrar"
}